const AUTH_PROVIDER_NAME_TRANSFORMATIONS = {
  "google-oauth2": "Google",
  canvas: "Canvas",
  classlink: "ClassLink",
  clever: "Clever",
  "microsoft-oauth2": "Microsoft",
  native: "Newsela",
  forms: "Newsela",
} as const;

export type AuthProviderOption =
  keyof typeof AUTH_PROVIDER_NAME_TRANSFORMATIONS;

export default AUTH_PROVIDER_NAME_TRANSFORMATIONS;
